import Vehicle from 'assets/images/psp/vehicle.webp';
import Climate from 'assets/images/psp/climate.webp';
import Hour24 from 'assets/images/psp/24Hour.webp';
import DriveUp from 'assets/images/psp/driveUp.webp';
import Electricity from 'assets/images/psp/electricity.webp';
import Wine from 'assets/images/psp/wine.webp';
import Business from 'assets/images/psp/business.webp';
import RV from 'assets/images/psp/rv.webp';
import Portable from 'assets/images/psp/portable.webp';
import BoatStorage from 'assets/images/psp/PSPLinks/BoatStorage.svg';
import College from 'assets/images/psp/college.webp';
import Military from 'assets/images/psp/military.webp';
import Car from 'assets/images/psp/car.webp';
import Motorcycle from 'assets/images/psp/motorcycle.webp';
import DirtBike from 'assets/images/psp/dirtbike.webp';
import ATV from 'assets/images/psp/atv.webp';
import Kayak from 'assets/images/psp/kayak.webp';
import Truck from 'assets/images/psp/truck.webp';
import JetSki from 'assets/images/psp/jetski.webp';
import Bike from 'assets/images/psp/bicycle.webp';
import GolfCart from 'assets/images/psp/golfCart.webp';

export const storageCategories = {
	access24Hour: ['climate', 'electricity', 'driveUp', 'portable'],
	climateControlled: ['wine', '24Hour', 'electricity', 'commercial'],
	driveUpAccess: ['rv', 'boat', '24Hour', 'vehicle'],
	portableStorage: ['university', 'military', 'climate', 'commercial'],
	electricityStorage: ['commercial', 'climate', 'car', 'rv'],
	wineStorage: ['climate', 'electricity', '24Hour', 'commercial'],
	collegeStudent: ['portable', 'climate', '24Hour', 'bike'],
	commercialBusiness: ['climate', 'electricity', '24Hour', 'portable'],
	military: ['portable', 'climate', 'car', '24Hour'],
	atv: ['motorcycle', 'dirtBike', 'vehicle', 'rv'],
	bicycle: ['motorcycle', 'university', 'vehicle', 'kayak'],
	boat: ['rv', 'jetSki', 'vehicle', 'driveUp'],
	car: ['vehicle', 'climate', 'rv', 'motorcycle'],
	dirtBike: ['motorcycle', 'atv', 'vehicle', 'bike'],
	golfCart: ['rv', 'atv', 'vehicle', 'driveUp'],
	jetSki: ['boat', 'kayak', 'vehicle', 'rv'],
	kayak: ['boat', 'jetSki', 'vehicle', 'bike'],
	motorcycle: ['vehicle', 'atv', 'dirtBike', 'car'],
	rv: ['boat', 'vehicle', 'driveUp', 'car'],
	truck: ['car', 'boat', 'jetSki', 'atv'],
	vehicle: ['car', 'rv', 'boat', 'motorcycle'],
	selfStorage: ['vehicle', 'climate', '24Hour', 'driveUp'],
};

export const contentMap = {
	vehicle: {
		title: 'Vehicle Self Storage',
		key: 'vehicle',
		url: '/storage-types/vehicle-self-storage',
		image: Vehicle,
		description: 'Secure vehicle self storage with easy access',
	},
	climate: {
		title: 'Climate Controlled Self Storage',
		key: 'climate',
		url: '/storage-types/climate-controlled-self-storage',
		image: Climate,
		description: 'Keep items safe in climate controlled self storage',
	},
	'24Hour': {
		title: '24 Hour Self Storage',
		key: '24Hour',
		url: '/storage-types/24-hour-self-storage',
		image: Hour24,
		description: 'Find convenient 24-hour self storage today',
	},
	driveUp: {
		title: 'Drive Up Self Storage',
		key: 'driveUp',
		url: '/storage-types/drive-up-self-storage',
		image: DriveUp,
		description: 'Drive-up self storage for easy loading',
	},
	electricity: {
		title: 'Self Storage With Electricity',
		key: 'electricity',
		url: '/storage-types/self-storage-with-electricity',
		image: Electricity,
		description: 'Self storage with electricity & power outlets',
	},
	wine: {
		title: 'Wine Self Storage',
		key: 'wine',
		url: '/storage-types/wine-self-storage',
		image: Wine,
		description: 'Protect your collection in wine self storage units',
	},
	commercial: {
		title: 'Commercial Self Storage',
		key: 'commercial',
		url: '/storage-types/commercial-self-storage',
		image: Business,
		description: 'Store inventory in secure commercial storage units',
	},
	rv: {
		title: 'RV Self Storage',
		key: 'rv',
		url: '/storage-types/rv-self-storage',
		image: RV,
		description: 'Spacious RV self storage for your next adventure',
	},
	boat: {
		title: 'Boat Self Storage',
		key: 'boat',
		url: '/storage-types/self-storage-for-boats',
		image: BoatStorage,
		description: 'Protect your boat with indoor boat self storage',
	},
	portable: {
		title: 'Portable Self Storage',
		key: 'portable',
		url: '/storage-types/portable-self-storage',
		image: Portable,
		description: 'Move flexibly with portable self storage units',
	},
	university: {
		title: 'University Self Storage',
		key: 'university',
		url: '/storage-types/student-self-storage',
		image: College,
		description: 'Affordable university self storage near campus',
	},
	military: {
		title: 'Military Self Storage',
		key: 'military',
		url: '/storage-types/military-self-storage',
		image: Military,
		description: 'Save with military discounts for self storage',
	},
	car: {
		title: 'Car Self Storage',
		key: 'car',
		url: '/storage-types/car-self-storage',
		image: Car,
		description: 'Reliable and secure car self storage near you',
	},
	motorcycle: {
		title: 'Motorcycle Self Storage',
		key: 'motorcycle',
		url: '/storage-types/motorcycle-self-storage',
		image: Motorcycle,
		description: 'Ride worry-free with motorcycle self storage',
	},
	dirtBike: {
		title: 'Dirt Bike Self Storage',
		key: 'dirtBike',
		url: '/storage-types/dirt-bike-self-storage',
		image: DirtBike,
		description: 'Find affordable dirt bike self storage nearby',
	},
	truck: {
		title: 'Truck Self Storage',
		key: 'truck',
		url: '/storage-types/self-storage-truck',
		image: Truck,
		description: 'Find affordable truck self storage nearby',
	},
	bike: {
		title: 'Bike Self Storage',
		key: 'bike',
		url: '/storage-types/bike-self-storage',
		image: Bike,
		description: 'Lock up safely in a convenient bike storage unit',
	},
	atv: {
		title: 'ATV Self Storage',
		key: 'atv',
		url: '/storage-types/atv-self-storage',
		image: ATV,
		description: 'Secure ATV self storage for your off-road gear',
	},
	kayak: {
		title: 'Kayak Self Storage',
		key: 'kayak',
		url: '/storage-types/kayak-self-storage',
		image: Kayak,
		description: 'Store your kayak safely year-round with ease',
	},
	jetSki: {
		title: 'Jet Ski Self Storage',
		key: 'jetSki',
		url: '/storage-types/jet-ski-self-storage',
		image: JetSki,
		description: 'Splash-ready protection in self storage for jet skis',
	},
	golfCart: {
		title: 'Golf Cart Storage',
		key: 'golfCart',
		url: '/storage-types/golf-cart-self-storage',
		image: GolfCart,
		description: 'Golf cart storage and parking solutions',
	},
};
